module.exports = __webpack_public_path__ + "img/soynet6.adf6fc8f.png";